import React from 'react';

import type { FC } from 'react';

export const Phone: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M16.0187 12.724L13.902 12.4823C13.3937 12.424 12.8937 12.599 12.5354 12.9573L11.002 14.4906C8.64369 13.2906 6.71035 11.3656 5.51035 8.99896L7.05202 7.45729C7.41035 7.09896 7.58535 6.59896 7.52702 6.09062L7.28535 3.99063C7.18535 3.14896 6.47702 2.51562 5.62702 2.51562H4.18535C3.24369 2.51562 2.46035 3.29896 2.51869 4.24062C2.96035 11.3573 8.65202 17.0406 15.7604 17.4823C16.702 17.5406 17.4854 16.7573 17.4854 15.8156V14.374C17.4937 13.5323 16.8604 12.824 16.0187 12.724Z" />
    </svg>
  );
};
